import {
  MatriculaMedidasItem,
  MedidasPorMatriculaResponse,
} from '../../../../../../common/types/MedidasPorMatricula'
import { Vehicle } from '../../../../../../common/types/Vehiculo'

function tyreBase(
  width: number,
  aspectRatio: number,
  rimDiameter: number,
  loadIndex: string | null,
  speedIndex: string | null
) {
  const normalized = `${width}/${aspectRatio} R${rimDiameter}`
  const loadAndSpeed =
    loadIndex && speedIndex ? ` ${loadIndex}${speedIndex}` : ''

  return {
    original: `${normalized}${loadAndSpeed}`.trim(),
    normalized,
    format: 'metric',
    width,
    aspectRatio,
    construction: 'R',
    rimDiameter,
    loadIndex,
    speedIndex,
    dualLoadIndex: null,
    extraLoad: false,
    runFlat: false,
    season: null,
    plyRating: null,
    highPerformance: false,
    isCommercial: false,
    isTemporary: false,
  }
}

function tyre(
  width: number,
  aspectRatio: number,
  rimDiameter: number,
  loadIndex: string,
  speedIndex: string
) {
  return tyreBase(width, aspectRatio, rimDiameter, loadIndex, speedIndex)
}

/** AMI sense IC/IV (ni al text original): simula resposta WS incompleta. */
function tyreWithoutLoadSpeed(
  width: number,
  aspectRatio: number,
  rimDiameter: number
) {
  return tyreBase(width, aspectRatio, rimDiameter, null, null)
}

const MEDIDAS_LLANTA_16_17: MatriculaMedidasItem[] = [
  {
    front_and_rear: tyre(205, 55, 16, '91', 'V'),
  },
  {
    front_and_rear: tyre(225, 45, 17, '94', 'W'),
  },
  {
    front_and_rear: tyre(195, 65, 16, '92', 'H'),
  },
]

const MEDIDAS_POR_VEHICULO: Record<number, MatriculaMedidasItem[]> = {
  90101: MEDIDAS_LLANTA_16_17,
  90102: MEDIDAS_LLANTA_16_17,
  90201: MEDIDAS_LLANTA_16_17,
  90301: MEDIDAS_LLANTA_16_17,
  90401: [
    { front_and_rear: tyre(180, 65, 16, '81', 'H') },
    { front_and_rear: tyre(180, 55, 17, '73', 'V') },
  ],
  /** 7524MTR: varias medidas AMI; taller = 205/55 R16 91V (primera opción) */
  90601: MEDIDAS_LLANTA_16_17,
  /** 2847NCI: AMI sense IC/IV (només ancho/serie/llanta) */
  90701: [
    { front_and_rear: tyreWithoutLoadSpeed(205, 55, 16) },
    { front_and_rear: tyreWithoutLoadSpeed(225, 45, 17) },
  ],
}

export function getDevMedidasForVehicle(
  vehicle: Vehicle
): MedidasPorMatriculaResponse | null {
  const medidas = MEDIDAS_POR_VEHICULO[vehicle.id_vehiculo]
  if (!medidas) return null
  return { medidas }
}
